module.exports = __webpack_public_path__ + "static/protects-8bdb2d35ce046c767b222e1d2911f1aa.svg";